import DailyIframe from '@daily-co/daily-js';

export const initDailyCall = async (url: string) => {
  // 1. Zombie Killer: Destroy any lingering instances
  const existingCall = DailyIframe.getCallInstance();
  if (existingCall) {
    console.log('💀 Killing zombie Daily instance...');
    await existingCall.destroy();
  }

  // 2. Create fresh instance (Removed the invalid iframeSettings)
  return DailyIframe.createCallObject({
    url
  });
};

export const destroyDailyCall = async () => {
  const call = DailyIframe.getCallInstance();
  if (call) {
    await call.destroy();
  }
};